var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "mb-20", attrs: { gutter: 10 } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "mb-5" }, [
              _c("b", [_vm._v(_vm._s(_vm.$t("DocumentDetail.documentNumber")))])
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "document_number" } }, [
              _vm._v(_vm._s(_vm.documentNumber))
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "mb-5" }, [
              _c("b", [_vm._v(_vm._s(_vm.$t("DocumentDetail.invoiceDate")))])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm._f("parseTime")(_vm.document.issue_date, "{d}-{m}-{y}")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "mb-5" }, [
              _c("b", [_vm._v(_vm._s(_vm.$t("DocumentDetail.invoiceDueDate")))])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm._f("parseTime")(_vm.document.due_date, "{d}-{m}-{y}")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "mb-5" }, [
              _c("b", [
                _vm._v(_vm._s(_vm.$t("DocumentDetail.lastDunningStatus")))
              ])
            ]),
            _vm._v(" "),
            _vm.document.dunning_status
              ? _c("div", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.document.dunning_status.message_code) +
                      "\n\t\t\t"
                  )
                ])
              : _c("div", [_vm._v("\n\t\t\t\t/\n\t\t\t")])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "disp-flex w-100 mb-20" }, [
        _c(
          "div",
          { staticClass: "mr-40" },
          [
            _c("span", { staticClass: "mr-10" }, [
              _vm._v(_vm._s(_vm.$t("DocumentDetail.totalAmount")))
            ]),
            _vm._v(" "),
            _c("el-tag", { attrs: { type: "primary" } }, [
              _vm._v(
                _vm._s(
                  _vm.$formatter.toCurrency(
                    _vm.document.total_amount,
                    _vm.document.amount_currency
                  )
                )
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("span", { staticClass: "mr-10" }, [
              _vm._v(_vm._s(_vm.$t("DocumentDetail.openAmount")))
            ]),
            _vm._v(" "),
            _c(
              "el-tag",
              {
                attrs: {
                  type: _vm.document.open_amount === 0 ? "success" : "danger"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$formatter.toCurrency(
                      _vm.document.open_amount,
                      _vm.document.amount_currency
                    )
                  )
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 10 } }, [
            _c(
              "div",
              { staticClass: "legalEntityInvoiceBlock" },
              [
                _c("el-card", { staticClass: "box-card no-shadow" }, [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("DocumentDetail.legalEntity")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-container fs-13" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("DocumentDetail.name")))]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.document.legal_entity_by_reference
                              .registration_name
                              ? _vm.document.legal_entity_by_reference
                                  .registration_name
                              : "/"
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.$translate.legal_id_type_description(
                                _vm.document.legal_entity_by_reference
                                  .company_id_type
                              )
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate.legal_id_type(
                                    _vm.document.legal_entity_by_reference
                                      .company_id_type
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.document.legal_entity_by_reference.company_id
                              ? _vm.document.legal_entity_by_reference
                                  .company_id
                              : "/"
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("DocumentDetail.address")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm.legalEntityAddressType === "FORMAL"
                          ? [
                              _c(
                                "div",
                                [
                                  _vm.document.legal_entity_by_reference.address
                                    .company_name
                                    ? _c("div", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.document
                                                .legal_entity_by_reference
                                                .address.company_name
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.legal_entity_by_reference
                                          .address.street_name
                                          ? _vm.document
                                              .legal_entity_by_reference.address
                                              .street_name
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.legal_entity_by_reference
                                          .address.street_number
                                          ? _vm.document
                                              .legal_entity_by_reference.address
                                              .street_number
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _vm.document.legal_entity_by_reference.address
                                    .post_box
                                    ? [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("DocumentDetail.post_box")
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.document
                                                .legal_entity_by_reference
                                                .address.post_box
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.document.legal_entity_by_reference
                                        .address.zip_code
                                        ? _vm.document.legal_entity_by_reference
                                            .address.zip_code
                                        : ""
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.document.legal_entity_by_reference
                                        .address.city
                                        ? _vm.document.legal_entity_by_reference
                                            .address.city
                                        : ""
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          : _vm.recipientAddressType === "INFORMAL"
                          ? [
                              _vm.document.legal_entity_by_reference.address
                                .company_name
                                ? _c("div", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.document.legal_entity_by_reference
                                            .address.company_name
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.document.legal_entity_by_reference
                                        .address.street_name_number_box
                                        ? _vm.document.legal_entity_by_reference
                                            .address.street_name_number_box
                                        : ""
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.document.legal_entity_by_reference
                                        .address.zip_code
                                        ? _vm.document.legal_entity_by_reference
                                            .address.zip_code
                                        : ""
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.document.legal_entity_by_reference
                                        .address.city
                                        ? _vm.document.legal_entity_by_reference
                                            .address.city
                                        : ""
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.document.legal_entity_by_reference
                                        .address.iso_country_code
                                        ? _vm.document.legal_entity_by_reference
                                            .address.iso_country_code
                                        : ""
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          : [
                              _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                      ],
                      2
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 4 } }, [
            _c("span", { staticClass: "invisible" }, [_vm._v(".")])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 10 } }, [
            _c(
              "div",
              { staticClass: "recipientInvoiceBlock" },
              [
                _c("el-card", { staticClass: "box-card no-shadow" }, [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$tc("DocumentDetail.recipient")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "right" },
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.handleRecipientClick }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("DocumentDetail.view")) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid-container fs-13" },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("DocumentDetail.customerNumber")))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.document.recipient_by_reference.account_id
                                  ? _vm.document.recipient_by_reference
                                      .account_id
                                  : "/"
                              ) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("DocumentDetail.name")))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.document.recipient_by_reference.name
                                ? _vm.document.recipient_by_reference.name
                                : "/"
                            ) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.document.recipient_by_reference.type === "B2B"
                        ? [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.$translate.legal_id_type_description(
                                        _vm.document.recipient_by_reference
                                          .legal_id_type
                                      )
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate.legal_id_type(
                                            _vm.document.recipient_by_reference
                                              .legal_id_type
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.document.recipient_by_reference.legal_id
                                      ? _vm.document.recipient_by_reference
                                          .legal_id
                                      : "/"
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("DocumentDetail.preferredInvoicingChannel")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.document.recipient_by_reference
                                .preferred_invoicing_channel
                                ? _vm.document.recipient_by_reference
                                    .preferred_invoicing_channel
                                : "/"
                            ) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("DocumentDetail.address")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.recipientAddressType === "FORMAL"
                            ? [
                                _vm.document.recipient_by_reference.address
                                  .company_name
                                  ? _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.document.recipient_by_reference
                                              .address.company_name
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.street_name
                                          ? _vm.document.recipient_by_reference
                                              .address.street_name
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.street_number
                                          ? _vm.document.recipient_by_reference
                                              .address.street_number
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.zip_code
                                          ? _vm.document.recipient_by_reference
                                              .address.zip_code
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.city
                                          ? _vm.document.recipient_by_reference
                                              .address.city
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.iso_country_code
                                          ? _vm.document.recipient_by_reference
                                              .address.iso_country_code
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]
                            : _vm.recipientAddressType === "INFORMAL"
                            ? [
                                _vm.document.recipient_by_reference.address
                                  .company_name
                                  ? _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.document.recipient_by_reference
                                              .address.company_name
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.street_name_number_box
                                          ? _vm.document.recipient_by_reference
                                              .address.street_name_number_box
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.zip_code
                                          ? _vm.document.recipient_by_reference
                                              .address.zip_code
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.city
                                          ? _vm.document.recipient_by_reference
                                              .address.city
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.document.recipient_by_reference
                                          .address.iso_country_code
                                          ? _vm.document.recipient_by_reference
                                              .address.iso_country_code
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]
                            : [
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]
                        ],
                        2
                      )
                    ],
                    2
                  )
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }